import {
  ArticleCard,
  AuthorByline,
  CardDate,
  Eyebrow,
  Image,
  Title,
} from '@/app_components/ArticleSections/ArticleCards/ArticleCard';
import type { ArticlePreviewGrid } from '@/app_lib/types/ArticlePreview';
import { getPrimarySection } from '@/app_lib/utils/utils';

export const ArticleCardGrid = ({
  article,
  className,
  priority,
}: {
  article: ArticlePreviewGrid;
  className?: string;
  priority?: boolean;
}) => {
  const primarySection = getPrimarySection({ primarySectionId: article.primarySectionId, sections: article.sections });

  return (
    <ArticleCard
      className={className}
      variant='grid'
    >
      <Image
        image={article.image}
        imageAlt={article.imageAlt}
        priority={priority}
        url={article.url}
        variant='grid'
      />
      <div className='flex flex-col gap-sm'>
        <Eyebrow
          sectionName={primarySection.name}
          sectionUrl={primarySection.url}
          variant='grid'
        />
        <Title
          title={article.title}
          url={article.url}
          variant='grid'
        />
      </div>
      <div className='flex flex-col'>
        <AuthorByline
          authors={article.authors}
          variant='grid'
        />
        <CardDate
          dateGmt={article.dateGmt}
          variant='grid'
        />
      </div>
    </ArticleCard>
  );
};
